import { EventEmitter, Injectable, Output, ViewChild } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, filter, take, switchMap, tap, map } from 'rxjs/operators';
// import { throwError, BehaviorSubject } from 'rxjs';
import { NzDrawerRef, NzModalService, NzNotificationService } from 'ng-zorro-antd';
import { AuthService } from '../auth/auth.service';
import * as urls from './urls';
import { AuthUser, User } from '../models/auth-user';
import { SessionExpiredError } from './errors';
import { Messages } from './message';
import { Config } from 'src/environments/config';
const omitEmpty = require('omit-empty');
import { EncryptionService } from '../encryption/encryption.service';
import { Router } from '@angular/router';
import { AuthRoutes } from './routes';
import { of, throwError, BehaviorSubject } from 'rxjs';

@Injectable()
export class GlobalHttpInterceptorService implements HttpInterceptor {
  private refreshTokenInProgress = false;

  // Refresh Token Subject tracks the current token, or is null if no token is currently
  // available (e.g. refresh pending).

  private refreshTokenSubject: BehaviorSubject < any > = new BehaviorSubject < any > (
      null
  );

  constructor(
      private notification: NzNotificationService,
      private authService: AuthService,
      private drawerRef: NzDrawerRef,
      private encryption: EncryptionService,
      private modalService: NzModalService,
      private router: Router 
) {}

//   intercept(request: HttpRequest < any > , next: HttpHandler): Observable < HttpEvent < any >> {
//       // Remove empty fields from request body
//       if (request.url.includes('/backoffice/user/update') ) {
//         request = request.clone({
//             body: request.body
//         });
//       } else {
//         request = request.clone({
//             body: omitEmpty(request.body)
//         });
//       }
      
//     //   console.log('URL:',request.url);
//     //   console.log('REQUEST:',request.body); 
//       if (this.checkIsEncrption(request.url) == false &&
//           request.method !== 'GET' && request.method !== 'DELETE') {
//           request = request.clone({
//               body: this.encryption.encrypt(request.body)
//           });
//           const response = {
//               requestData: request.body,
//           };
//           request = request.clone({
//               body: response
//           });
          
//       }
//       return next.handle(this.addAuthenticationToken(request)).pipe(
//           map((event: HttpEvent < any > ) => {
//               if (event instanceof HttpResponse) {
//                   if (event.body && event.body.responseData) {
//                       if (this.checkIsEncrption(request.url) == false) {
//                           event = event.clone < any > ({
//                               body: this.encryption.decrypt(event.body.responseData),
//                           });
//                       }
//                   }
//               }
//               return event;
//           }),
//           catchError((error) => {
//               // We don't want to refresh token for some requests like login or refresh token itself
//               // So we verify url and we throw an error if it's the case
//               if (request.url.includes(urls.AuthUrls.refreshCustomToken) || request.url.includes(urls.AuthUrls.login) || request.url.includes(urls.AuthUrls.verifyOTP)) {
//                   // We do another check to see if refresh token failed
//                   // In this case we want to logout user and to redirect it to login page

//                   this.refreshTokenInProgress = false;
//                   if (request.url.includes(urls.AuthUrls.refreshCustomToken)) {
//                       this.authService.onNotify(true);
//                       this.authService.logout();
//                       return this.handleError(new SessionExpiredError(), this.notification);
//                   }

//                   return this.handleError(error, this.notification);
//               }

//               if (error.status !== 401) {
//                   return this.handleError(error, this.notification);
//               }

//               if (this.refreshTokenInProgress) {
//                   // If refreshTokenInProgress is true, we will wait until refreshTokenSubject has a non-null value
//                   // – which means the new token is ready and we can retry the request again
//                   return this.refreshTokenSubject.pipe(
//                       filter((result) => result !== null),
//                       take(1),
//                       switchMap(() =>
//                           next.handle(this.addAuthenticationToken(request)).pipe(
//                               map((event: HttpEvent < any > ) => {
//                                   if (event instanceof HttpResponse) {
//                                     if (event.body && event.body.responseData) {
//                                           if (this.checkIsEncrption(request.url) == false) {
//                                               event = event.clone < any > ({
//                                                   body: this.encryption.decrypt(
//                                                       event.body.responseData
//                                                   ),
//                                               });
//                                           }
//                                       }
//                                   }
//                                   return event;
//                               })
//                           )
//                       ),
//                       catchError((err: any) => {
//                           this.refreshTokenInProgress = false;
//                           if (err instanceof HttpErrorResponse && err.error && err.error.statusCode === 400) {
//                               return this.handleError(err, this.notification);
//                           } else {
//                               this.authService.onNotify(true); // For Drawer Close
//                               this.authService.logout();
//                               return this.handleError(err, this.notification);
//                           }
//                       })
//                   );
//               } else {
//                   this.refreshTokenInProgress = true;

//                   // Set the refreshTokenSubject to null so that subsequent API calls will wait until the new token has been retrieved
//                   this.refreshTokenSubject.next(null);

//                   // Call auth.refreshAccessToken(this is an Observable that will be returned)
//                   // return this.authService
//                   return this.authService.refreshCustomTokens().pipe(
//                       switchMap((authUser: User) => {
//                           // When the call to refreshToken completes we reset the refreshTokenInProgress to false
//                           // for the next time the token needs to be refreshed
//                           this.refreshTokenInProgress = false;
//                           this.refreshTokenSubject.next(authUser.data.customToken);

//                           return next.handle(this.addAuthenticationToken(request)).pipe(
//                               map((event: HttpEvent < any > ) => {
//                                   if (event instanceof HttpResponse) {
//                                       if (event.body && event.body.responseData) {
//                                           if (this.checkIsEncrption(request.url) === false) {
//                                               event = event.clone < any > ({
//                                                   body: this.encryption.decrypt(
//                                                       event.body.responseData
//                                                   ),
//                                               });
//                                           }
//                                       }
//                                   }
//                                   return event;
//                               })
//                           );
//                       }),
//                       catchError((err: any) => {
//                           this.refreshTokenInProgress = false;
//                           if (err.error && err.error.statusCode === 400) {
//                               return this.handleError(err, this.notification);
//                           } else {
//                             this.authService.onNotify(true); // For Drawer Close
//                             this.authService.logout();
//                             return this.handleError(err, this.notification);
//                           }
//                       })
//                   );
//               }
//           })
//       );
//   }

intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  // Remove empty fields from request body unless it's user update
  if (request.url.includes('/backoffice/user/update')) {
    request = request.clone({ body: request.body });
  } else {
    request = request.clone({ body: omitEmpty(request.body) });
  }

  // Encrypt request if required
  if (this.checkIsEncrption(request.url) === false &&
      request.method !== 'GET' && request.method !== 'DELETE') {
    request = request.clone({
      body: this.encryption.encrypt(request.body)
    });
    const response = { requestData: request.body };
    request = request.clone({ body: response });
  }

  return next.handle(this.addAuthenticationToken(request)).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse && event.body.responseData) {
        if (this.checkIsEncrption(request.url) === false) {
          event = event.clone({
            body: this.encryption.decrypt(event.body.responseData)
          });
        }
      }
      return event;
    }),
    catchError((error) => {
  
      if (
  request.url === urls.AuthUrls.refreshCustomToken &&
  !this.authService.getAuthToken()
) {
  this.refreshTokenInProgress = false;
  this.refreshTokenSubject.next(null);

  return throwError(error);
}
      // Exclude certain URLs from token refresh
      const isExcludedUrl =
  request.url.includes(urls.AuthUrls.refreshCustomToken) ||
  request.url.includes(urls.AuthUrls.login) ||
  request.url.includes(urls.AuthUrls.verifyOTP) ||
  request.url.includes(urls.AuthUrls.resendOTP) ||
  request.url.includes(urls.AuthUrls.logout);

      if (isExcludedUrl) {
console.log('🟠 EXCLUDED AUTH API ERROR', {
    url: request.url,
    status: error.status,
    route: this.router.url,
    hasToken: !!this.authService.getAuthToken()
});
  if (request.url.includes(urls.AuthUrls.logout)) {
    return throwError(error);
  }

  if (request.url.includes(urls.AuthUrls.refreshCustomToken)) {
  this.refreshTokenInProgress = false;
  this.refreshTokenSubject.next(null);

  // OTP/login phase mein authenticated session exist nahi karta.
  if (!this.authService.getAuthToken()) {
    return throwError(error);
  }

  return this.handleError(
    new SessionExpiredError(),
    this.notification
  );
}

  return this.handleError(error, this.notification);
}

      // Handle 401 only
      if (error.status !== 401) {
        return this.handleError(error, this.notification);
      }

      // Never attempt token refresh without an authenticated session.
if (!this.authService.getAuthToken()) {
  return throwError(error);
}

      if (this.refreshTokenInProgress) {
        return this.refreshTokenSubject.pipe(
          filter((token) => token !== null),
          take(1),
          switchMap(() =>
            next.handle(this.addAuthenticationToken(request)).pipe(
              map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse && event.body.responseData) {
                  if (this.checkIsEncrption(request.url) === false) {
                    event = event.clone({
                      body: this.encryption.decrypt(event.body.responseData)
                    });
                  }
                }
                return event;
              })
            )
          ),
          catchError((err: any) => {
            this.refreshTokenInProgress = false;
            this.authService.onNotify(true);
            this.authService.logout();
            return this.handleError(err, this.notification);
          })
        );
      } else {
        this.refreshTokenInProgress = true;
        this.refreshTokenSubject.next(null);

        // Step 1: Refresh main custom token
        return this.authService.refreshCustomTokens().pipe(
          switchMap((authUser: User) => {
            this.refreshTokenInProgress = false;
            this.refreshTokenSubject.next(authUser.data.customToken);

            // Step 2: Refresh remit token if needed
           return this.authService.refreshRemitTokens().pipe(
  catchError(() => {
    // Remit refresh failure must not invalidate
    // the main FlexBiz session.
    return of(null);
  }),
              switchMap(() =>
                next.handle(this.addAuthenticationToken(request)).pipe(
                  map((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse && event.body.responseData) {
                      if (this.checkIsEncrption(request.url) === false) {
                        event = event.clone({
                          body: this.encryption.decrypt(event.body.responseData)
                        });
                      }
                    }
                    return event;
                  })
                )
              )
            );
          }),
          catchError((err: any) => {
            this.refreshTokenInProgress = false;
            this.authService.onNotify(true);
            this.authService.logout();
            return this.handleError(err, this.notification);
          })
        );
      }
    })
  );
}


  private handleError(error: any, notification: NzNotificationService) {
   
      if (error.error && error.error instanceof ErrorEvent) {
          // A client-side or network error occurred. Handle it accordingly.
          notification.error('error', 'An error occurred:' + error.error.message, {
              nzKey: 'key',
          });
      } else if (error instanceof SessionExpiredError) {
        console.error('🚨 SESSION EXPIRED TRIGGERED', {
        route: this.router.url,
        hasToken: !!this.authService.getAuthToken(),
        refreshInProgress: this.refreshTokenInProgress
    });

    console.trace('SESSION EXPIRED TRACE');
    if (this.authService.getAuthToken()) {
        notification.error('error', error.message, {
            nzKey: 'key'
        });

        this.router.navigate([AuthRoutes.login]);
    }
} else if (error instanceof HttpErrorResponse) {
        if (error.url.includes(urls.AuthUrls.tokenValidate)) {
        } else {
          this.handleHttpErrorResponse(error, notification);
        }
      }
      return throwError(error);
  }

//   private checkIsEncrption(url) {
//       if (url.includes('/attachment/create/') || url.includes('/download/') || url.includes('/upload') || url.includes('/business/receive-payment/details')||
//       url.includes('merchant/image/upload') || url.includes('business/account/add-money/paynow')) {
//           console.log('checkIsEncrption');
//           return true;
//       } else {
//           return false;
//       }
//   }
  private checkIsEncrption(url) {
      if (url.includes('/business/bulk-uplod/batch/create') || url.includes('/download/') || url.includes('/upload') || url.includes('/business/receive-payment/details')|| url.includes('/business/direct-remittance-payment/details') ||
      url.includes('merchant/image/upload') || url.includes('business/account/add-money/paynow') ||   url.includes(Config.remitUrl) || url.includes('/business/send-money-direct-remittance') || url.includes('/business/transaction-epf/direct-payment/QRdetails')) {
        //   console.log('checkIsEncrption');
          return true;
      } else {
          return false;
      }
  }

  private handleHttpErrorResponse(
      error: HttpErrorResponse,
      notification: NzNotificationService
  ) {
      switch (error.status) {
          case 401:
              notification.error(error.error.message, '', {
                  nzKey: 'key'
              });
              break;
          case 400:
              if (error.error.message === Messages.noData) {
                  break;
              } else {
                  notification.error(error.error.message, '', {
                      nzKey: 'key'
                  });
                  break;
              }
              case 404:
                notification.error(error.error.message, '', {
                    nzKey: 'key'
                });
                break;
              default:
                  if (error.status === 0) {
                    notification.error(Messages.unKnownError, '', {
                        nzKey : 'key'
                    });
                  } else {
                    notification.error('error', 'An error occurred:' + error.message, {
                        nzKey: 'key',
                    });
                  }
      }
  }

//   private addAuthenticationToken(request) {
//       if (request.url.includes(urls.AuthUrls.login)) {
//           return request;
//       }

//       const authToken: string = this.authService.getAuthToken();
//       let newHeaders = request.headers;
//       if (authToken) {
//           // If we have a token, we append it to our new headers
//           newHeaders = newHeaders.append('Authorization', `${authToken}`);
//           newHeaders = newHeaders.append('X-API-KEY', Config.apiKey);
//       }
//       // Finally we have to clone our request with our new headers
//       // This is required because HttpRequests are immutable
//       return request.clone({
//           headers: newHeaders
//       });
//   }


private addAuthenticationToken(
  request: HttpRequest<any>
): HttpRequest<any> {

  const publicAuthUrls = [
    urls.AuthUrls.login,
    urls.AuthUrls.verifyOTP,
    urls.AuthUrls.resendOTP
  ];

  if (publicAuthUrls.some(url => request.url === url)) {
    return request.clone({
      headers: request.headers
        .delete('Authorization')
        .delete('X-API-KEY')
    });
  }

  let newHeaders = request.headers;

  if (request.url.includes(Config.remitUrl)) {
    const remitToken = this.authService.getAccessTokenRemit();

    if (remitToken) {
      newHeaders = newHeaders.set(
        'Authorization',
        `Bearer ${remitToken}`
      );
    }
  } else {
    const authToken = this.authService.getAuthToken();

    if (authToken) {
      newHeaders = newHeaders.set(
        'Authorization',
        authToken
      );

      newHeaders = newHeaders.set(
        'X-API-KEY',
        Config.apiKey
      );
    }
  }

  return request.clone({ headers: newHeaders });
}


  closeDrawer(value) {
      if (value) {
          return value;
      }
  }
}